const REFRESH_TOKEN_KEY = 'bs-talent-refresh-token'

let accessToken: string | null = null
let refreshHandler: (() => Promise<string>) | null = null
let refreshInFlight: Promise<string> | null = null

export function getAccessToken() {
  return accessToken
}

export function setAccessToken(token: string | null) {
  accessToken = token
}

export function getRefreshToken() {
  return window.sessionStorage.getItem(REFRESH_TOKEN_KEY)
}

export function setRefreshToken(token: string | null) {
  if (token) {
    window.sessionStorage.setItem(REFRESH_TOKEN_KEY, token)
  } else {
    window.sessionStorage.removeItem(REFRESH_TOKEN_KEY)
  }
}

export function clearSessionTokens() {
  setAccessToken(null)
  setRefreshToken(null)
}

export function registerRefreshHandler(handler: (() => Promise<string>) | null) {
  refreshHandler = handler
}

export function refreshAccessToken() {
  if (!refreshHandler) return Promise.reject(new Error('No authenticated session'))
  if (refreshInFlight) return refreshInFlight

  refreshInFlight = refreshHandler().finally(() => {
    refreshInFlight = null
  })
  return refreshInFlight
}
